import { FaFile, FaFileCsv, FaFileExcel, FaFileImage, FaFilePdf, FaFileWord } from 'react-icons/fa6'
import { IconType } from 'react-icons'

export type AttachmentVisualTone = 'pdf' | 'image' | 'spreadsheet' | 'document' | 'default'

export interface AttachmentVisual {
  Icon: IconType
  tone: AttachmentVisualTone
}

export const getAttachmentVisual = (filetype?: string, filename?: string): AttachmentVisual => {
  const type = (filetype || '').toLowerCase()
  const name = (filename || '').toLowerCase()
  const extension = name.includes('.') ? name.split('.').pop() || '' : ''

  if (type === 'application/pdf' || extension === 'pdf') {
    return { Icon: FaFilePdf, tone: 'pdf' }
  }

  if (
    type.startsWith('image/') ||
    ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(extension)
  ) {
    return { Icon: FaFileImage, tone: 'image' }
  }

  if (type === 'text/csv' || extension === 'csv') {
    return { Icon: FaFileCsv, tone: 'spreadsheet' }
  }

  if (
    type.includes('spreadsheet') ||
    type.includes('excel') ||
    ['xls', 'xlsx', 'ods'].includes(extension)
  ) {
    return { Icon: FaFileExcel, tone: 'spreadsheet' }
  }

  if (
    type.includes('word') ||
    type.includes('msword') ||
    ['doc', 'docx', 'odt', 'rtf'].includes(extension)
  ) {
    return { Icon: FaFileWord, tone: 'document' }
  }

  return { Icon: FaFile, tone: 'default' }
}
